import {CurrentRisk, RiskLimits} from "../models/RiskSummaryRecord";

type InputType = RiskLimits & CurrentRisk;

export function isOverStelLimit(input: InputType): boolean {
    return (input.stelLimit != null) && (input.currentStel > input.stelLimit);
}

export function isOverMarginLimit(input: InputType): boolean {
    return (input.marginLimit != null) && (input.currentAsxMargin > input.marginLimit);
}

export function isOverCbplLimit(input: InputType): boolean {
    return (input.cbplLimit != null) && (input.currentCbpl > input.cbplLimit);
}

export function requiresMarginLimit(input: InputType): boolean {
    return (input.marginLimit == null) && (input.currentClientMargin > 0);
}
